/* eslint react/no-array-index-key: 0 */
import React from 'react';
import PlacesAutocomplete from 'react-places-autocomplete';
// @ts-ignore
import { ControlLabel, FormControl } from 'react-bootstrap';
import { Loader } from 'semantic-ui-react';

import './AddressInput.scss';

interface AddressInputProps {
  label?: string;
  value: string;
  required?: boolean;
  onChange?: (value: string) => void;
  name?: string;
  testId?: string;
}

const AddressInput = (props: AddressInputProps) => (
  <div className="AddressInput">
    <PlacesAutocomplete
      value={props.value ?? ''}
      debounce={500}
      onChange={props.onChange}
      searchOptions={{
        types: ['address'],
        componentRestrictions: { country: ['us', 'ca'] },
      }}
    >
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <div>
          <ControlLabel>
            {props.label ?? 'Address'} {props.required ? '*' : ''}
          </ControlLabel>
          <FormControl
            {...getInputProps()}
            required={props.required}
            value={props.value}
            name={props.name}
            data-testid={props.testId}
          />
          <div className="AddressInput-suggestionsContainer">
            {loading && <Loader size="medium" />}
            <div className="AddressInput-suggestionsContainer-suggestions">
              {suggestions.map((suggestion, index) => (
                <div
                  {...getSuggestionItemProps(suggestion, {})}
                  key={`${suggestion.description} + ${index}`}
                  data-testid={`${props.testId}-suggestion-${index}`}
                >
                  <span>{suggestion.description}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </PlacesAutocomplete>
  </div>
);

export default AddressInput;
